import { useDynamicEntity } from './useDynamicEntity';
import { useAuth, useLeaveTypes } from './index';
import { calculateDuration } from '../utils/dateUtils';

const useLeaveRequests = (userId = null) => {
  const { user } = useAuth();
  const { leaveTypes } = useLeaveTypes();
  
  const targetUserId = userId || user?.id;

  const isHourlyLeaveType = (leaveTypeId) => {
    if (!leaveTypeId || !Array.isArray(leaveTypes)) return false;
    const id = parseInt(leaveTypeId, 10);
    const lt = leaveTypes.find(x => x.id === id);
    if (!lt) return false;

    const name = lt.leave_type_name?.toLowerCase().trim() || '';
    const days = lt.leave_type_days ?? 0;
    const hours = lt.leave_type_hours ?? 0;

    if (hours > 0 && (!days || days === 0)) return true;
    if (
      name.includes('saatlik') ||
      name.includes('hourly') ||
      name.includes(' saat ')
    ) {
      return true;
    }
    return false;
  };

  const dynamicHook = useDynamicEntity({
    entityType: 'leaves',
    gqlEntityKey: 'leave_requests',
    queryName: 'GET_LEAVE_REQUESTS_QUERY',
    createMutation: 'CREATE_LEAVE_REQUEST_MUTATION',
    updateMutation: 'UPDATE_LEAVE_REQUEST_MUTATION',
    deleteMutation: 'DELETE_LEAVE_REQUEST_MUTATION',
    serverPagination: true,
    aggregateKey: 'leave_requests_aggregate',
    customWhereCondition: { user_id: { _eq: targetUserId } },
    transformData: leaveRequest => ({
      id: leaveRequest.id,
      startDate: leaveRequest.start_date,
      endDate: leaveRequest.end_date,
      leaveTypeName:
        leaveRequest.leaveType?.leave_type_name || leaveRequest.leave_type,
      leaveTypeId: leaveRequest.leaveType?.id || null,
      description: leaveRequest.leave_request_description || '',
      duration: leaveRequest.duration,
      status: leaveRequest.status,
      is_team_manager_approved: leaveRequest.is_team_manager_approved,
      is_group_manager_approved: leaveRequest.is_group_manager_approved,
    }),
    transformFormData: formData => {
      const isHourly = isHourlyLeaveType(formData.leaveType);
      const transformedData = {
        start_date: formData.startDate,
        end_date: formData.endDate,
        leave_type: formData.leaveType,
        leave_request_description: formData.leave_request_description || null,
        duration: calculateDuration(formData.startDate, formData.endDate, isHourly),
        company_id: user?.companyId || user?.company?.id,
        user_id: targetUserId,
        team_id: user?.team_id || null,
        group_id: user?.team?.group_id || null,
        status: 'PENDING',
      };

      return transformedData;
    },
  });

  return {
    ...dynamicHook,
    leaveRequests: dynamicHook.leaves,
  };
};

export { useLeaveRequests };
